import { NumberInput } from '@framework/form/inputs/NumberInput.tsx';
import { FormItem } from '@framework/form/item/FormItem.tsx';
import { ColSpanInputPopover } from './col-span-popover/ColSpanInputPopover.tsx';

export interface IBaseLayoutColSpanInputProps {
  isTableColumn: boolean;
}
/**
 * Input di configurazione per la larghezza in colonne del widget
 * valido quando è posizionato in un elemento di tipo Riga.
 */
export function BaseLayoutColSpanInput(props: IBaseLayoutColSpanInputProps) {
  const { isTableColumn } = props;

  return isTableColumn ? (
    <FormItem name="layout.tableColumnWidth" label="Larghezza colonna">
      <NumberInput name="layout.tableColumnWidth" addonAfter="%" />
    </FormItem>
  ) : (
    <FormItem
      name="layout.colSpan"
      label="Numero Colonne"
      popover={{
        content: <ColSpanInputPopover />,
      }}
      help="Larghezza del campo in proporzione agli altri campi della stessa Riga; fuori da una Riga non ha effetto."
    >
      <NumberInput name="layout.colSpan" />
    </FormItem>
  );
}
